import { render, staticRenderFns } from "./NoticeRepresentativeProduct.vue?vue&type=template&id=97b019ca&scoped=true&"
import script from "./NoticeRepresentativeProduct.vue?vue&type=script&lang=js&"
export * from "./NoticeRepresentativeProduct.vue?vue&type=script&lang=js&"
import style0 from "./NoticeRepresentativeProduct.vue?vue&type=style&index=0&id=97b019ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../nonspa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b019ca",
  null
  
)

/* custom blocks */
import block0 from "./NoticeRepresentativeProduct.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

component.options.__file = "NoticeRepresentativeProduct.vue"
export default component.exports